import React, { useCallback } from 'react';
import styled from 'styled-components';
import { isString } from 'lodash-es';
const StyledContainer = styled.div `
  flex: 1;
  display: inline-flex;
  align-items: center;
  min-width: 0;
  box-sizing: border-box;
`;
const StyledValue = styled.span `
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const TableCell = ({ className, onClick = () => { }, value, }) => {
    const title = isString(value) ? value : '';
    const handleClick = useCallback(() => {
        onClick(value);
    }, [onClick, value]);
    return (React.createElement(StyledContainer, { className: className, onClick: handleClick, title: title },
        React.createElement(StyledValue, null, value)));
};
export default TableCell;
